import { PublishTradingOfferModalContextType } from '../types/PublishTradingOfferModalContextType';

export const publishTradingOfferModalInitValue: PublishTradingOfferModalContextType =
  {
    data: {
      modalActionType: '',
      tradingOffer: null,
      publishedOffer: null,
      validityDays: 0,
      isTermsAndConditionsAccepted: false,
      isHideSellerName: false,
      isLoading: true,
      currentStep: 1,
      publisherPartner: null,
      publisherDocuments: [],
    },
    actions: {
      handleCloseModal: () => {},
      handleNextStep: () => {},
      handlePrevStep: () => {},
      handleChangeTermsAndConditionsAcceptance: () => {},
      handleChangeHideSellerName: () => {},
      handleAddPublisherDocument: () => {},
      handleRemovePublisherDocument: () => {},
      handleUpdatePublisherPartnerField: () => {},
      handleUpdatePublisherPartnerAddressField: () => {},
      handlePublishTradingOffer: async () => {},
    },
  };
